import React from "react";
import Button from "../components/Button";

export default ({ data, click }) => {
	return (
		<div>
			<h3 className="friends-hdg">
				<i className="fa fa-user-circle-o fa-lg" />
				<span>{`${data.friend} is a friendrasier for ${data.charity}`}</span>
			</h3>

			<div
				className={data.image ? "friends-container" : "friends-container empty"}
			>
				{data.image ? (
					<img src={data.image} alt="Charity" />
				) : (
					<img
						src={`https://via.placeholder.com/600/FFFFFF`}
						alt="Placeholder"
						style={{ display: "none" }}
					/>
				)}

				<div>
					<p style={{ marginTop: "0" }}>{data.mission}</p>
					{!data.open ? (
						<p className="error">
							Thank you for your interest is making a donation through Champions{" "}
							<i>fore</i> Charity. The 2026-2027 fundraising campaign season
							will open October 14.
							{/*Thank you for your interest is making a donation through Champions{" "}
							<i>fore</i> Charity. The 2026-2027 fundraising campaign season
							closed on April 12th. The 2027-2028 campaign season will kick off
							this fall in October.*/}
						</p>
					) : (
						<div className="donate-link-container">
							{!data.donateForm && (
								<Button
									label="Donate Now"
									iconLeft="fa-file-text-o"
									name="donateForm"
									click={click}
								/>
							)}
							<Button
								label={
									data.copyLink ? "Copied to Clipboard" : "Copy My Donate Link"
								}
								iconLeft={data.copyLink ? "fa-check" : "fa-clipboard"}
								name="copyLink"
								click={click}
							/>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
